import styled from 'styled-components';

export const Wrapper = styled.div`
    display: grid;
    max-width: 150px;
    grid-column-gap: 12px;
    margin-bottom: 35px;
    & img {
        grid-column: 1;
        grid-row: 1/3;
        width: 40px;
        height: 40px;
    }
`;
export const Text = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.02em;
    color: #ffffff;
    grid-column: 2;
`;
export const CompanyText = styled(Text)`
    /* font-family: 'Avenir'; */
    font-weight: 800;
    font-size: 21px;
    line-height: 29px;
    letter-spacing: -0.02em;
`;
